// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-top[data-v-68bf9fdb] {\n  position: sticky;\n  top: 0px;\n  z-index: 10;\n}\n.firmador-select[data-v-68bf9fdb] {\n  width: 75px;\n  height: auto;\n}", ""]);
// Exports
module.exports = exports;
